import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { UserService } from 'src/app/services/user/user.service';
import * as alertifyjs from 'alertifyjs';
import { PlanService } from './plan.service';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.css'],
  providers: [DatePipe],
})
export class PlansComponent implements OnInit {
  plans: any;
  plans_loading: any;
  status_plans: any = true; // Necesario para la vista legacy (filtro de botones)
  plans_active: any;
  plans_inactive: any;
  showOld = false;
  viewMode: 'dashboard' | 'legacy' = 'dashboard';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    private datePipe: DatePipe,
    private offcanvasService: NgbOffcanvas,
    public _auth: AuthService,
    private _planService: PlanService
  ) {}

  ngOnInit(): void {
    if (this.viewMode === 'legacy') {
    this.getPlans();
    }
  }

  toggleView(): void {
    this.viewMode = this.viewMode === 'dashboard' ? 'legacy' : 'dashboard';
    this.showOld = this.viewMode === 'legacy';

    if (this.viewMode === 'legacy' && !this.plans) {
      this.getPlans();
    }
  }

  deletePlan = async (item: any) => {
    try {
      await this._user.deletePlan({ code_plan: item });
      this.getPlans();
      alertifyjs.success('eliminación exitosa');
    } catch (error: any) {
      alertifyjs.error(error?.error?.msg);
    }
  }

  getPlans = async (plans_loading = true) => {
    try {
      this.plans_loading = plans_loading;

      // Carga TODOS los planes sin filtro de status
      let plans = await this._user.getplansall({});
      let plansInvoices = (await this._user.getplansInvoices({}))?.res;

      this.plans = plans?.res?.map((item: any) => {
        item.invoices = plansInvoices[item._id] || 0;
        return item;
       });

      this.plans_active =
        this.plans?.filter((item: any) => item.status == true)?.length > 0
          ? true
          : false;

      this.plans_inactive =
        this.plans?.filter((item: any) => item.status != true)?.length > 0
          ? true
          : false;

    } catch (error: any) {
      console.log(error);
    }
    this.plans_loading = false;
  };

  pocisionBottom = async (content: TemplateRef<any>, data: any = {}) => {
    try {
      this.offcanvasService.open(content, {
        position: 'bottom',
        keyboard: false,
      });
    } catch (error) {
      console.log(error);
    }
  };

  activePlan = async (code_plan: any) => {
    try {
      console.log(`🔄 Activating plan: ${code_plan}`);

      // Get the complete plan object first
      const planResponse = await this._planService.getPlanByCode(code_plan).toPromise();

      console.log('📡 Plan response from API:', planResponse);

      if (!planResponse || !planResponse.res) {
        throw new Error('No se pudo obtener el plan completo');
      }

      // Update only the status and state fields in the complete plan object
      const completePlan = { ...planResponse.res };
      completePlan.status = true;
      completePlan.state = 'ACTIVE';

      console.log('📤 Sending updated plan to API:', {
        code: completePlan.code,
        status: completePlan.status,
        state: completePlan.state
      });

      // Send the complete plan object to the API
      const updateResponse = await this._planService.updatePlan(completePlan);

      console.log('📡 Update response:', updateResponse);

      alertifyjs.success('Plan activado exitosamente');

      // Actualizar el estado local del plan sin recargar desde servidor
      if (this.plans) {
        const planIndex = this.plans.findIndex((p: any) => p.code === code_plan);
        if (planIndex !== -1) {
          this.plans[planIndex].status = true;
          this.plans[planIndex].state = 'ACTIVE';
        }
      }
    } catch (error: any) {
      console.error('❌ Error activating plan:', error);

      // More detailed error logging
      if (error.error) {
        console.error('❌ API Error details:', error.error);
      }

      const errorMessage = error?.error?.msg ||
                          error?.error?.message ||
                          error?.message ||
                          'Error al activar plan';

      alertifyjs.error(errorMessage);
    }
  };

  close() {
    this.offcanvasService.dismiss('');
    // ELIMINADO: this.getPlans(false); - No recargar datos al cerrar modal
  }

  showPlan(plan: any, content: TemplateRef<any>) {
    this._planService.selectedPlan = plan;
    try {
      this.offcanvasService.open(content, {
        position: 'bottom',
        keyboard: false,
      });
    } catch (error) {
      console.log(error);
    }
  }
}

